import { defineComponent, ref, computed } from 'vue-demi';
import { openBlock, createElementBlock, normalizeClass, renderSlot } from 'vue';

const Tab = [
// Layout
'layout-inline-row justify-center',
// Spacing
'-mb-[1px]', 'px-0', 'py-[6px]',
// Interactivity
'interactivity-click',
// Typography
'typography-body-2-bold',
// Theme
'theme-foreground-secondary', 'dark:theme-foreground-secondary-dark', 'theme-border-transparent border-b-2', 'dark:theme-border-transparent-dark',
// Theme (hover)
'hover:md:theme-foreground-default', 'dark:hover:md:theme-foreground-default-dark',
// Theme (active)
'active:theme-foreground-default', 'dark:active:theme-foreground-default-dark', 'active:theme-border-current active:border-b-2', 'dark:active:theme-border-current-dark',
// Theme (selected)
'selected:theme-foreground-default', 'dark:selected:theme-foreground-default-dark', 'selected:theme-border-current selected:border-b-2', 'dark:selected:theme-border-current-dark',
// Theme (invalid)
'invalid:theme-foreground-error', 'dark:invalid:theme-foreground-error-dark',
// Theme (invalid + hover)
'hover:invalid:md:theme-foreground-error-hover', 'dark:hover:invalid:md:theme-foreground-error-hover-dark',
// Theme (invalid + active)
'active:invalid:theme-foreground-error', 'dark:active:invalid:theme-foreground-error-dark', 'active:invalid:theme-border-current active:invalid:border-b-2', 'dark:active:invalid:theme-border-current-dark'];

var script = defineComponent({
  name: 'OrTab',
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click', 'focus', 'blur'],
  expose: ['root'],
  setup() {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-tab-v3', ...Tab]);
    return {
      root,
      rootStyles
    };
  }
});

const _hoisted_1 = ["selected", "invalid", "disabled"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    selected: _ctx.selected,
    invalid: _ctx.invalid,
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('click', $event)),
    onFocus: _cache[1] || (_cache[1] = $event => _ctx.$emit('focus', $event)),
    onBlur: _cache[2] || (_cache[2] = $event => _ctx.$emit('blur', $event))
  }, [renderSlot(_ctx.$slots, "default")], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1);
}

script.render = render;
script.__file = "src/components/or-tab-v3/OrTab.vue";

export { script as s };
